import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { ViewRequestStatusAction } from "../../../redux/actions/GlobalAction";
import { getDispatch, getSnackbarSuccess } from "../../../Utils/helper";
import { IS_PAGE_EDIT } from "../../../Utils/types";

export const EditSaveHandler = ({
  isShowViewButton,
  moduleName,
  userProfileDetail,
  values,
}) => {
  const dispatch = useDispatch();
  const [option, setOption] = useState([
    "City Name",
    "Area Name",
    "Company Type (LLP/Pvt Ltd)",
    "Special Characters",
    "Numbers",
  ]);
  const [data, setData] = useState(null);
  const [checkbox, setCheckbox] = useState([]);
  const isPageEdit = useSelector((state) => state?.globalReducer?.isPageEdit);
  const viewStatusButton = useSelector(
    (state) => state?.globalReducer?.viewStatusButton
  );

  useEffect(() => {
    if (moduleName) {
      dispatch(ViewRequestStatusAction(moduleName));
    }
  }, [moduleName]);
  useEffect(() => {
    if (userProfileDetail) {
      setData(userProfileDetail[0]);
    }
  }, [userProfileDetail]);
  console.log(values?.displayProviderName, data?.displayProviderName);
  return (
    <div className="edit-save-row">
      {viewStatusButton?.isShowStatusButton &&
        !isPageEdit &&
        !isShowViewButton && (
          <button
            className="btn btn-primary me-2"
            data-bs-toggle="modal"
            type="button"
            data-bs-target="#viewstatusModal"
            onClick={() => dispatch(ViewRequestStatusAction(moduleName))}
          >
            View Status
          </button>
        )}
      {!isPageEdit && (
        <button
          className="btn btn-primary me-2"
          type="button"
          onClick={() => {
            getSnackbarSuccess(
              "info",
              !isPageEdit
                ? "You are able to edit now"
                : "You are not able to edit now",
              dispatch
            );
            getDispatch(IS_PAGE_EDIT, true, dispatch);
          }}
        >
          Edit Details
        </button>
      )}
      {isPageEdit && (
        <>
          {values?.displayProviderName === data?.displayProviderName ? (
            <button className="btn btn-primary" type="submit">
              Save Details
            </button>
          ) : (
            <button
              className="btn btn-primary"
              data-bs-toggle="modal"
              type="button"
              data-bs-target="#dispalyNameVilidate"
            >
              Save Details
            </button>
          )}
        </>
      )}
      <div
        className="modal fade"
        id="viewstatusModal"
        tabIndex="-1"
        aria-labelledby="viewstatusModalLabel"
        aria-hidden="true"
      >
        <div className="modal-dialog">
          <div className="modal-content modal-content-status">
            <div className="modal-body">
              <div className="d-flex justify-content-between align-items-center">
                <h4
                  className={`font-bold mb-0 modal-status-h4 ${
                    viewStatusButton?.ticketStatus?.requestStatus === "Rejected"
                      ? "reject-color"
                      : viewStatusButton?.ticketStatus?.requestStatus ===
                        "Approved"
                      ? "approve-color"
                      : "pending-color"
                  }`}
                >
                  {viewStatusButton?.ticketStatus?.requestStatus}
                </h4>
                <button
                  type="button"
                  className="btn-close history-close"
                  data-bs-dismiss="modal"
                  aria-label="Close"
                ></button>
              </div>
              <hr />
              <div className="__viewStatus">
                <p style={{ color: "black" }}>
                  <strong>Remark: </strong>
                  {viewStatusButton?.ticketStatus?.remarks}
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div
        class="modal fade"
        id="dispalyNameVilidate"
        tabindex="-1"
        role="dialog"
        aria-labelledby="exampleModalCenterTitle"
        aria-hidden="true"
      >
        <div class="modal-dialog modal-dialog-centered " role="document">
          <div class="modal-content">
            <div
              className="d-flex justify-content-between border-bottom modalHeader"
              style={{ borderRadius: "10px 10px 0px 0px" }}
            >
              <h4 className="font-bold text-black">Please read carefully</h4>
              <button
                type="button"
                className="btn-close history-close"
                aria-label="Close"
                data-bs-dismiss="modal"
              ></button>
            </div>
            <div className="modal-body " style={{ padding: "0 30px" }}>
              <p className="p-2" style={{ fontWeight: "600px" }}>
                The Display Name will be visible to the customer. So please make
                sure you have excluded these things from the Display Name.
              </p>
              <div className="select-time-interval" style={{ height: "100%" }}>
                {option?.map((ele) => {
                  return (
                    <div className="d-flex gap-3">
                      <div style={{ fontSize: "15px", padding: "3px" }}>
                        <input
                          className="form-check-input"
                          type="checkbox"
                          checked={checkbox?.some((element) => element === ele)}
                          onClick={(e) => {
                            if (e.target.checked) {
                              setCheckbox([...checkbox, ele]);
                            } else {
                              let arr = checkbox.filter((item) => item !== ele);
                              setCheckbox(arr);
                            }
                          }}
                        />
                      </div>
                      <label style={{ fontSize: "13px", padding: "3px" }}>
                        {ele}
                      </label>
                    </div>
                  );
                })}
              </div>
            </div>
            <div className="modal-footer modal-footer-admin accept-reject-btns  accept-reject-btns-admin bottom-0 ">
              <div>
                <button
                  className="savedetails"
                  aria-label="Close"
                  data-bs-dismiss="modal"
                  disabled={option?.length !== checkbox?.length}
                  type="submit"
                  // onClick={() => {}}
                >
                  Submit
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export const isPageEditFalse = (dispatch) => {
  dispatch({
    type: IS_PAGE_EDIT,
    payload: false,
  });
};
